import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { TileArt } from "@/components/SelectedWork";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FILTERS = [
  ["all", "All"],
  ["architecture", "Brand Architecture"],
  ["identity", "Identity"],
  ["culture", "Entertainment + Culture"],
  ["grateful-merry", "Grateful & Merry"],
  ["campaigns", "Campaigns"],
  ["digital", "Digital"],
  ["experiences", "Experiences"],
];

export default function AllWork() {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    axios
      .get(`${API}/projects`)
      .then((res) => {
        const ps = (res.data.projects || []).slice();
        ps.sort((a, b) => parseInt(a.number, 10) - parseInt(b.number, 10));
        setProjects(ps);
      })
      .catch(() => {});
  }, []);

  const visible = filter === "all" ? projects : projects.filter((p) => p.filter === filter);

  return (
    <main>
      <Nav />
      <div data-testid="all-work-page" className="px-6 md:px-12 lg:px-24 pt-32 md:pt-44 pb-28 min-h-screen">
        <Reveal>
          <header className="mb-14 md:mb-20">
            <p className="text-[11px] uppercase tracking-[0.34em] text-charcoal-mute mb-6">
              The Danielle Edit — Archive
            </p>
            <h1 className="font-serif text-5xl md:text-8xl leading-[0.95] tracking-tight">
              All <span className="italic text-chrome">Work</span>
            </h1>
          </header>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="flex flex-wrap gap-x-8 gap-y-3 border-y border-charcoal/10 py-5 mb-14 md:mb-20">
            {FILTERS.map(([key, label]) => (
              <button
                key={key}
                data-testid={`filter-btn-${key}`}
                onClick={() => setFilter(key)}
                className={`text-[11px] uppercase tracking-[0.26em] transition-colors duration-300 pb-1 border-b ${
                  filter === key
                    ? "text-charcoal border-charcoal"
                    : "text-charcoal-mute border-transparent hover:text-charcoal"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="flex flex-wrap justify-center gap-x-8 gap-y-14">
          {visible.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08} className="w-full sm:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]">
              <Link to={`/work/${p.slug}`} data-testid={`archive-tile-${p.slug}`} className="group block">
                <div className="relative overflow-hidden border border-charcoal/10 aspect-[4/3]">
                  <TileArt project={p} />
                </div>
                <div className="flex items-baseline justify-between mt-4 border-t border-charcoal/10 pt-3">
                  <div>
                    <p className="text-[10px] uppercase tracking-[0.26em] text-charcoal-mute mb-1">
                      {p.tags[0]} · {p.year}
                    </p>
                    <h3 className="font-serif text-lg md:text-xl group-hover:italic transition-all duration-300">
                      {p.title}
                    </h3>
                  </div>
                  <ArrowUpRight
                    className="w-4 h-4 shrink-0 text-charcoal-mute group-hover:text-charcoal group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300"
                    strokeWidth={1.25}
                  />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        {visible.length === 0 && (
          <p className="text-sm text-charcoal-mute py-20">Nothing in this chapter yet.</p>
        )}
      </div>
      <Footer />
    </main>
  );
}
